module.exports = __webpack_public_path__ + "static/mid-b6a169e74174713bd6ed9a158edd287e.png";